module.exports = __webpack_public_path__ + "static/media/logo.403d1b20.svg";